"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onAction: function(_event) {
          this.emit(_event, this.input.reference);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/components/Outline.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "card"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "row m-0 no-gutters d-flex align-items-stretch"
      },
    marko_attrs3 = {
        "class": "col-md-3 col-12 d-flex"
      },
    marko_attrs4 = {
        "class": "col"
      },
    marko_attrs5 = {
        "class": "card-body"
      },
    marko_attrs6 = {
        "class": "card-text text-ellipsis-2 font-medium-3"
      },
    marko_attrs7 = {
        "class": "font-small-3 text-ellipsis-2 text-muted"
      },
    marko_attrs8 = {
        "class": "col-3 pr-4 text-right d-flex align-items-center"
      },
    marko_attrs9 = {
        "class": "mt-4"
      },
    marko_attrs10 = {
        "class": "badge badge-dark"
      },
    marko_attrs11 = {
        "class": "px-50 cursor-pointer",
        title: "Edit"
      },
    marko_attrs12 = {
        "class": "px-50 cursor-pointer",
        title: "Delete"
      },
    marko_attrs13 = {
        "class": "d-inline-block px-50 move-handle cursor-move",
        title: "Move"
      },
    marko_attrs14 = {
        "class": "text-right pb-50",
        style: "margin-top:-10px"
      },
    marko_attrs15 = {
        "class": "font-small-2 text-muted"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("353e0e"),
    marko_node0 = marko_createElement("span", {
        "class": "text-primary"
      }, "25", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("From"),
    marko_attrs16 = {
        "class": "font-small-2 text-muted"
      },
    marko_node1 = marko_createElement("span", {
        "class": "text-primary"
      }, "27", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t(" To");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "data-index": input.index
    }, "0", component);

  out.be("div", marko_attrs0, "1", component);

  out.be("div", marko_attrs1, "2", component);

  out.be("div", marko_attrs2, "3", component);

  out.be("div", marko_attrs3, "4", component);

  Image_tag({
      alt: input.title,
      src: input.poster,
      class: "w-100 rounded-left",
      icon: "bx bxs-landscape"
    }, out, __component, "5");

  out.ee();

  out.be("div", marko_attrs4, "6", component);

  out.be("div", marko_attrs5, "7", component);

  out.e("div", marko_attrs6, "8", component, 1)
    .t(input.title, component);

  out.e("div", marko_attrs7, "9", component, 1)
    .t(input.description, component);

  if (input.isPublished) {
    out.be("div", marko_attrs9, "10", component);

    out.be("span", marko_attrs10, "11", component);

    Locale_tag({
        text: "Published"
      }, out, __component, "12");

    out.ee();

    out.ee();
  }

  out.ee();

  out.ee();

  out.be("div", marko_attrs8, "13", component);

  route_link_tag({
      href: (("/" + input.type) + "/") + input.id,
      class: "px-50 cursor-pointer",
      title: "Open",
      renderBody: function(out) {
        Bx_tag({
            type: "link-external",
            class: "font-medium-5"
          }, out, __component, "15");
      }
    }, out, __component, "14");

  if (input.editable) {
    out.be("span", marko_attrs11, "16", component, null, 0, {
        onclick: __component.d("click", "onAction", false, [
            "edit"
          ])
      });

    Bx_tag({
        type: "pencil",
        class: "font-medium-5"
      }, out, __component, "17");

    out.ee();

    out.be("span", marko_attrs12, "18", component, null, 0, {
        onclick: __component.d("click", "onAction", false, [
            "delete"
          ])
      });

    Bx_tag({
        type: "trash",
        class: "font-medium-5"
      }, out, __component, "19");

    out.ee();

    out.be("span", marko_attrs13, "20", component);

    Bx_tag({
        type: "dots-vertical-rounded",
        class: "font-medium-5 p-0 text-muted",
        style: "width:5px"
      }, out, __component, "21");

    Bx_tag({
        type: "dots-vertical-rounded",
        class: "font-medium-5 p-0 text-muted",
        style: "width:5px;"
      }, out, __component, "22");

    out.ee();
  }

  out.ee();

  out.ee();

  out.ee();

  out.ee();

  if (input.schedule && (!isEmpty(input.schedule))) {
    const { start, end } = input.schedule

    out.be("div", marko_attrs14, "23", component);

    if (start && (!isEmpty(start))) {
      out.e("span", marko_attrs15, "24", component, 3)
        .n(marko_node0, component)
        .t(" ")
        .t(start.date + (start.time ? " " + start.time : ""), component);
    }

    if (end && (!isEmpty(end))) {
      out.e("span", marko_attrs16, "26", component, 4)
        .t(" - ")
        .n(marko_node1, component)
        .t(" ")
        .t(end.date + (end.time ? " " + end.time : ""), component);
    }

    out.ee();
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
